import { ResponseSuccess } from '@websolutespa/payload-utils/server';
import { PayloadHandler, PayloadRequest } from 'payload';
import { options } from '../options';
import { errorHandler } from './error.handler';
import { AppToolOption, LlmApp } from './types';

export const appToolsHandler: PayloadHandler = async (req: PayloadRequest) => {
  try {
    const { payload } = req;

    // load app
    const llmAppId = (req.query.llmApp || '') as string;
    const llmApp = await payload.findByID({
      collection: options.slug.llmApp,
      id: llmAppId,
      overrideAccess: true,
    }) as LlmApp;

    // get app tools (only knowledgebase tools)
    const onlyActive = req.query.onlyActive !== undefined;
    const appTools = llmApp?.settings?.appTools.filter((tool) => tool.dataSource === 'knowledgebase' && (tool.isActive || !onlyActive)) || [];

    // create options array
    const appToolsOpts: AppToolOption[] = appTools.map(tool => ({
      value: tool.functionId,
      label: tool.name,
    }));

    return ResponseSuccess(appToolsOpts);
  } catch (error: any) {
    return errorHandler(error);
  }
};
